import { render, staticRenderFns } from "./fiyatlistesi.vue?vue&type=template&id=2e57003b&"
import script from "./fiyatlistesi.vue?vue&type=script&lang=js&"
export * from "./fiyatlistesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports